(function () {
  'use strict';

  var GSAP_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';
  var ST_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js';

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      if (document.querySelector('script[data-story-scroll-src="' + src + '"]')) {
        var existing = document.querySelector('script[data-story-scroll-src="' + src + '"]');
        if (existing.dataset.loaded === 'true') return resolve();
        existing.addEventListener('load', function () { resolve(); });
        existing.addEventListener('error', reject);
        return;
      }
      var s = document.createElement('script');
      s.src = src;
      s.async = false;
      s.dataset.storyScrollSrc = src;
      s.addEventListener('load', function () { s.dataset.loaded = 'true'; resolve(); });
      s.addEventListener('error', reject);
      document.head.appendChild(s);
    });
  }

  function loadGsap() {
    if (window.gsap && window.ScrollTrigger) return Promise.resolve();
    return loadScript(GSAP_SRC).then(function () { return loadScript(ST_SRC); });
  }

  function initCtas(container) {
    var ctas = Array.from(container.querySelectorAll('[data-story-cta]'));
    if (!ctas.length) return;
    if (!('IntersectionObserver' in window)) {
      ctas.forEach(function (c) { c.classList.add('story-scroll__cta--drawn'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('story-scroll__cta--drawn');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.35 });
    ctas.forEach(function (c) { obs.observe(c); });
  }

  function init(container) {
    if (!container || container.dataset.storyScrollInit === 'true') return;
    container.dataset.storyScrollInit = 'true';

    initCtas(container);

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var sections = Array.from(container.querySelectorAll('[data-flow-section]'));
    if (!sections.length) return;

    if (reducedMotion) {
      sections.forEach(function (section, i) { section.style.zIndex = String(i + 1); });
      return;
    }

    loadGsap().then(function () {
      var gsap = window.gsap;
      var ScrollTrigger = window.ScrollTrigger;
      gsap.registerPlugin(ScrollTrigger);

      var triggers = [];

      sections.forEach(function (section, i) {
        gsap.set(section, { zIndex: i + 1 });
        var inner = section.querySelector('.story-scroll__inner');
        if (!inner) return;

        if (i > 0) {
          gsap.set(inner, { rotation: 30, transformOrigin: 'bottom left' });
          var tween = gsap.to(inner, {
            rotation: 0,
            ease: 'none',
            scrollTrigger: {
              trigger: section,
              start: 'top bottom',
              end: 'top 25%',
              scrub: true,
            },
          });
          if (tween.scrollTrigger) triggers.push(tween.scrollTrigger);
        }

        if (i < sections.length - 1) {
          triggers.push(
            ScrollTrigger.create({
              trigger: section,
              start: 'bottom bottom',
              end: 'bottom top',
              pin: true,
              pinSpacing: false,
            })
          );
        }
      });

      ScrollTrigger.refresh();

      container._storyScrollKill = function () {
        triggers.forEach(function (t) { t.kill(); });
      };
    }).catch(function (err) {
      console.error('[story-scroll] failed to load GSAP', err);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-story-scroll]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-story-scroll]');
    if (el) init(el);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var el = e.target.querySelector('[data-story-scroll]');
    if (el && typeof el._storyScrollKill === 'function') el._storyScrollKill();
  });
})();
